/**
 * Renderer - Utility class for common rendering operations
 * Provides helper methods for drawing game elements with the neon/glow aesthetic.
 */

export class Renderer {
  constructor(ctx, canvas) {
    this.ctx = ctx;
    this.canvas = canvas;
  }

  /**
   * Draw text with a glow effect.
   */
  drawGlowText(text, x, y, { font = '24px "Share Tech Mono", monospace', color = '#ffffff', glowColor = '#00ffff', glowSize = 10, align = 'center', baseline = 'middle' } = {}) {
    const ctx = this.ctx;
    ctx.save();
    ctx.font = font;
    ctx.textAlign = align;
    ctx.textBaseline = baseline;

    // Glow effect
    ctx.shadowColor = glowColor;
    ctx.shadowBlur = glowSize;
    ctx.fillStyle = color;
    ctx.fillText(text, x, y);

    // Second pass for brighter center
    ctx.shadowBlur = glowSize / 2;
    ctx.fillText(text, x, y);

    ctx.restore();
  }

  /**
   * Draw a filled circle with optional glow.
   */
  drawGlowCircle(x, y, radius, { color = '#ffffff', glowColor = '#00ffff', glowSize = 15 } = {}) {
    const ctx = this.ctx;
    ctx.save();
    ctx.shadowColor = glowColor;
    ctx.shadowBlur = glowSize;
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  /**
   * Clear the canvas with the game background color.
   */
  clearBackground() {
    const ctx = this.ctx;
    const w = this.canvas.width;
    const h = this.canvas.height;

    const gradient = ctx.createLinearGradient(0, 0, 0, h);
    gradient.addColorStop(0, '#000000');
    gradient.addColorStop(1, '#0a0a2e');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, w, h);
  }
}
